import { Injectable, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';

export enum DisplayMode {
    GridFlow = 'gridflow',
    GridMobile = 'gridmobile',
    CoverFlow = 'coverflow',
}

@Injectable({
    providedIn: 'root',
})
export class OrientationService {

    private displayModeSubject = new Subject<DisplayMode>();
    displayMode$: Observable<DisplayMode> = this.displayModeSubject.asObservable();

    constructor(
        private readonly ngZone: NgZone,
        private readonly platform: Platform,
    ) {

        const screenOrientation = screen.orientation || screen['mozOrientation'] || screen['msOrientation'];

        if (screenOrientation) {
            screenOrientation.addEventListener('change', (event) => {
                this.ngZone.run(() => {
                    this.handleOrientationChange();
                });
            });
        }

        window.addEventListener('resize', (event) => {
            this.ngZone.run(() => {
                this.handleOrientationChange();
            });
        });

    }

    public handleOrientationChange() {
        const orientation = this.getMode();
        this.displayModeSubject.next(orientation);
    }

    private getMode(): DisplayMode {
        if (this.platform.is('desktop') || this.platform.is('ipad') || this.platform.is('tablet')) {
            return DisplayMode.GridFlow;
        } else if (!this.platform.is('cordova') && !this.platform.is('android') && !this.platform.is('iphone')) {
            return DisplayMode.GridFlow;
        } else if (this.platform.is('mobile') || this.platform.is('mobileweb') || this.platform.is('phablet')) {
            return window.innerWidth > window.innerHeight
                ? DisplayMode.CoverFlow
                : DisplayMode.GridMobile;
        } else {
            return DisplayMode.GridFlow;
        }
    }
}